<template>
  <span v-if="shows">{{ shows.length }} shows since 2015</span>
  <div class="lg:flex">
    <div class="flex-1">
      <Loader :loaded="loaded" />
      <Show :showData="show" v-for="show in shows" :key="show.date" />
    </div>

  </div>
  
</template>
<script>
  import Show from './Show'
  import Loader from '../common/Loader'
  import axios from 'axios'

  export default {
    components: { Loader, Show },
    name: 'ShowList',
    data: function() {
      return { shows: [], loaded: false }
    },
    methods: {
      gallery: function() {
        return [
          { id: 0, src: "img/hello2.jpeg", credit: "Loïse Doyen", link: "https://loisedoyen.com/" },
          { id: 1, src: "img/hello.jpg", credit: "Loïse Doyen", link: "https://loisedoyen.com/" },
          { id: 2, src: "img/hello3.jpg", credit: "Chiptography", link: "https://chiptography.com/" },
        ]
      }
    },
    mounted: function() {
      axios
        .get('/files/shows.json')
        .then(response => {
          response.data.forEach(show => show.date = show.date.replaceAll('-', '.'))
          this.shows = response.data.sort((a, b) => { return a.date > b.date ? -1 : 1 })
          this.loaded = true
        })
    }
  }
</script>
<style scoped>
  .shows {
    height: 800px;
  }
</style>